// Debug flag - set to true to enable console logging
const CATALOG_DEBUG = false;

// EOL SKUs array - Discontinued SKU variants that should be removed from display
// Loaded from theme settings (window.EOL_SKUS) - falls back to empty array if not set
const EOL_SKUS = window.EOL_SKUS || [];

// Helper function to check if a variant is EOL
function isEOLVariant(variant) {
  if (!variant || !variant.sku) return false;
  return EOL_SKUS.includes(String(variant.sku));
}

// Helper function to add frame_size parameter to URL
// This ensures collection->PDP links carry the currently selected frame-size
function addFrameSizeToUrl(url, productCard) {
  if (!url || !productCard) return url;

  try {
    // Get the currently selected frame size from the product card
    const selectedFrameButton = productCard.querySelector(
      ".catalog-section__product-card-frame-size-btn.is-active",
    );

    if (!selectedFrameButton) return url;

    const frameSize = selectedFrameButton.dataset?.frameSize;
    if (!frameSize) return url;

    // Normalize frame size to lowercase for URL parameter
    const normalizedSize = frameSize.toLowerCase();

    // Parse URL and add frame_size parameter
    const urlObj = new URL(url, window.location.origin);
    urlObj.searchParams.set("frame_size", normalizedSize);

    return urlObj.toString();
  } catch (e) {
    if (CATALOG_DEBUG) {
      console.warn("[CATALOG_DEBUG] Error adding frame_size to URL:", e);
    }
    return url;
  }
}

// Add global error handler for catalog section
window.addEventListener("error", function (event) {
  if (
    event.error &&
    event.error.stack &&
    event.error.stack.includes("catalog")
  ) {
    const errorMsg = `Global Error: ${event.error.message} at ${event.filename}:${event.lineno}`;
    localStorage.setItem("catalog_last_error", errorMsg);
    console.error("[CATALOG GLOBAL ERROR]:", errorMsg);
  }
});

// Prevent any form submissions within catalog section
document.addEventListener(
  "submit",
  function (event) {
    const catalogSection = event.target.closest(".catalog-section");
    if (catalogSection) {
      console.warn("[CATALOG] Form submission prevented in catalog section");
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    }
  },
  true,
);

document.addEventListener("DOMContentLoaded", function () {
  // Check for stored errors from previous session
  const storedError = localStorage.getItem("catalog_last_error");
  if (storedError) {
    console.error("[CATALOG ERROR FROM LAST SESSION]:", storedError);
    // alert("Last Add to Cart Error: " + storedError);
    localStorage.removeItem("catalog_last_error");
  }

  initializeCatalogSection();
});

function initializeCatalogSection() {
  handleKlaviyoReviewCounts();
  initializeMultiSkuProducts();
  handleFilterTabs();
  handleFrameSizeClicks();
  handleSwatchClicks();
  handleAddToCart();
  attachFrameSizeToProductLinks();

  // Initialize visibility for initially visible frame size buttons
  initializeFrameSizeButtonVisibility();

  // Check EOL for all frame size buttons on initial load
  checkEOLForFrameSizeButtons();

  // Initialize product URLs with variant IDs after a small delay
  setTimeout(() => {
    initializeProductUrls();
  }, 100);
}

// Initialize visibility style for frame size buttons that are initially visible
function checkEOLForFrameSizeButtons() {
  // Check all frame size buttons for EOL variants and hide them
  const allCards = document.querySelectorAll(".catalog-section__product-card");

  allCards.forEach((card) => {
    const frameSizeButtons = card.querySelectorAll(
      ".catalog-section__product-card-frame-size-btn",
    );

    frameSizeButtons.forEach((button) => {
      const variantSku = button.dataset?.sku;
      if (variantSku && EOL_SKUS.includes(String(variantSku))) {
        // Hide EOL variants (like PDP does)
        button.classList.add("hidden");
      } else {
        // Show non-EOL variants
        button.classList.remove("hidden");
      }
    });
  });
}

function initializeFrameSizeButtonVisibility() {
  const allProductCards = document.querySelectorAll(
    ".catalog-section__product-card",
  );

  allProductCards.forEach((productCard) => {
    // Update frame size buttons for each card (this will set visibility)
    updateFrameSizeButtons(productCard);
  });
}

// Attach frame_size parameter to product links when clicked
// This ensures the selected frame size is carried to PDP even if URL wasn't updated yet
function attachFrameSizeToProductLinks() {
  const productLinks = document.querySelectorAll(
    '.catalog-section__product-card a[href*="/products/"]',
  );

  productLinks.forEach((link) => {
    if (!link) return;

    const addFrameSizeOnClick = (e) => {
      const productCard = link.closest(".catalog-section__product-card");
      if (!productCard) return;

      // Check if link is disabled (EOL variant)
      if (
        link.href === undefined ||
        link.classList.contains(
          "catalog-section__product-card-image-link--disabled",
        )
      ) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      try {
        const currentUrl = new URL(link.href, window.location.origin);

        // Get the currently selected frame size from the product card
        const selectedFrameButton = productCard.querySelector(
          ".catalog-section__product-card-frame-size-btn.is-active",
        );

        // Check if selected variant is EOL
        if (selectedFrameButton) {
          const variantSku = selectedFrameButton.dataset?.sku;
          if (variantSku && EOL_SKUS.includes(String(variantSku))) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }

          const frameSize = selectedFrameButton.dataset?.frameSize;
          if (frameSize) {
            const normalizedSize = frameSize.toLowerCase();
            currentUrl.searchParams.set("frame_size", normalizedSize);
            link.href = currentUrl.toString();
          }
        }
      } catch (e) {
        if (CATALOG_DEBUG) {
          console.warn("[CATALOG_DEBUG] Error adding frame_size on click:", e);
        }
      }
    };

    // Add click handler to ensure frame_size is added on click
    link.addEventListener("click", addFrameSizeOnClick, { capture: true });
    link.addEventListener("auxclick", (e) => {
      if (e.button === 1) addFrameSizeOnClick(e); // Middle mouse button
    });
  });
}

// Initialize all product card URLs with variant IDs
function initializeProductUrls() {
  const allCards = document.querySelectorAll(".catalog-section__product-card");

  if (CATALOG_DEBUG) {
    console.log(
      `[CATALOG_DEBUG] Initializing URLs for ${allCards.length} product cards`,
    );
  }

  allCards.forEach((card) => {
    if (!card) return;

    // Get the active frame size button
    const selectedButton = card.querySelector(
      ".catalog-section__product-card-frame-size-btn.is-active",
    );

    if (!selectedButton) {
      if (CATALOG_DEBUG) {
        console.warn(
          "[CATALOG_DEBUG] No active frame size button found for card",
        );
      }
      return;
    }

    const variantId = selectedButton.dataset?.variantId;
    const imageWrapper = card.querySelector(
      ".catalog-section__product-card-image",
    );
    const baseUrl = imageWrapper?.getAttribute("data-base-url");

    if (!baseUrl || !variantId) {
      if (CATALOG_DEBUG) {
        console.warn("[CATALOG_DEBUG] Missing baseUrl or variantId:", {
          baseUrl,
          variantId,
        });
      }
      return;
    }

    // Check if this is a kit product
    const productGrid = card.closest(".catalog-section__product-grid-item");
    const productHandle =
      productGrid?.dataset?.productHandle?.toLowerCase() || "";
    const isKit = productGrid?.querySelector("[data-is-bundle='true']");
    const addToCartButton = card.querySelector(
      ".catalog-section__product-card-add-to-cart-btn",
    );

    let newUrl = `${baseUrl}?variant=${variantId}`;

    // Add addons for kit products
    if (isKit && addToCartButton) {
      const addons = [];
      const sideshieldId = addToCartButton?.dataset?.sideshieldId;
      const riserId = addToCartButton?.dataset?.riserId;
      const floatieId = addToCartButton?.dataset?.floatieId;

      // Determine if this product should use the nose shield addon
      const isRefugio = productHandle.includes("refugio");

      // Add appropriate addons
      if (sideshieldId) addons.push("sideshields");
      if (riserId) addons.push(isRefugio ? "noseshield" : "riser");
      if (floatieId) addons.push("floatie");

      if (addons.length > 0) {
        newUrl += `&addons=${addons.join(",")}`;
      }
    }

    // Add frame_size parameter to carry selected frame size to PDP
    newUrl = addFrameSizeToUrl(newUrl, card);

    // Check if selected variant is EOL
    const variantSku = selectedButton.dataset?.sku;
    const isVariantEOL = variantSku && EOL_SKUS.includes(String(variantSku));

    // Update image link - disable if EOL
    const imageLink = imageWrapper?.querySelector(
      ".catalog-section__product-card-image-link",
    );
    if (imageLink) {
      if (isVariantEOL) {
        // Convert anchor to disabled div if EOL (only if it's still an anchor)
        if (imageLink.href !== undefined) {
          const imageContent = imageLink.innerHTML;
          const newDiv = document.createElement("div");
          newDiv.className =
            "catalog-section__product-card-image-link catalog-section__product-card-image-link--disabled";
          newDiv.style.cssText = "pointer-events: none; cursor: default;";
          newDiv.innerHTML = imageContent;
          imageLink.parentNode.replaceChild(newDiv, imageLink);
        }
      } else {
        // Update href for non-EOL variants (restore if it was converted to div)
        if (imageLink.href !== undefined) {
          imageLink.href = newUrl;
        } else if (
          imageLink.classList.contains(
            "catalog-section__product-card-image-link--disabled",
          )
        ) {
          // Restore from disabled div to anchor
          const imageContent = imageLink.innerHTML;
          const newAnchor = document.createElement("a");
          newAnchor.className = "catalog-section__product-card-image-link";
          newAnchor.href = newUrl;
          newAnchor.innerHTML = imageContent;
          imageLink.parentNode.replaceChild(newAnchor, imageLink);
        }
      }
    }

    // Update review link - disable if EOL
    const reviewLink = card.querySelector(
      ".catalog-section__product-card-header-review-link",
    );
    if (reviewLink) {
      if (isVariantEOL) {
        // Convert anchor to disabled div if EOL (only if it's still an anchor)
        if (reviewLink.href !== undefined) {
          const reviewContent = reviewLink.innerHTML;
          const newDiv = document.createElement("div");
          newDiv.className = "catalog-section__product-card-header-review-link";
          newDiv.style.cssText = "pointer-events: none; cursor: default;";
          newDiv.innerHTML = reviewContent;
          reviewLink.parentNode.replaceChild(newDiv, reviewLink);
        }
      } else {
        // Update href for non-EOL variants (restore if it was converted to div)
        if (reviewLink.href !== undefined) {
          reviewLink.href = `${newUrl}#pdp-review-section`;
        } else {
          // Restore from disabled div to anchor
          const reviewContent = reviewLink.innerHTML;
          const newAnchor = document.createElement("a");
          newAnchor.className =
            "catalog-section__product-card-header-review-link";
          newAnchor.href = `${newUrl}#pdp-review-section`;
          newAnchor.role = "link";
          newAnchor.innerHTML = reviewContent;
          reviewLink.parentNode.replaceChild(newAnchor, reviewLink);
        }
      }
    }

    // Update any other product links in the card
    const allProductLinks = card.querySelectorAll('a[href*="/products/"]');
    allProductLinks.forEach((link) => {
      if (!link || !link.href) return;

      if (link.href.includes(baseUrl.split("?")[0])) {
        const hash = link.href.includes("#") ? link.href.split("#")[1] : "";
        link.href = hash ? `${newUrl}#${hash}` : newUrl;
      }
    });

    if (CATALOG_DEBUG) {
      console.log("[CATALOG_DEBUG] Initialized URLs for card:", {
        variantId,
        newUrl,
        isKit: !!isKit,
      });
    }
  });

  if (CATALOG_DEBUG) {
    console.log("[CATALOG_DEBUG] All product URLs initialized");
  }
}

function initializeMultiSkuProducts() {
  // Find all multi-sku product cards
  const multiSkuCards = document.querySelectorAll(
    ".catalog-section__product-card[data-multi-sku-variants]",
  );

  if (CATALOG_DEBUG) {
    console.log(
      `[CATALOG_DEBUG] Found ${multiSkuCards.length} multi-sku product cards`,
    );
  }

  multiSkuCards.forEach((productCard, index) => {
    // Find all swatches in this product card
    const swatches = productCard.querySelectorAll(
      ".catalog-section__product-card-swatch",
    );

    if (swatches.length > 0) {
      // Remove active class from all swatches first
      swatches.forEach((swatch) => swatch.classList.remove("is-active"));

      // Add active class to the first swatch
      const firstSwatch = swatches[0];
      firstSwatch.classList.add("is-active");

      if (CATALOG_DEBUG) {
        console.log(
          `[CATALOG_DEBUG] Card ${index + 1}: Set first swatch as active`,
          {
            variantId: firstSwatch.dataset.variantId,
            frameColor: firstSwatch.dataset.frameColor,
            lensColor: firstSwatch.dataset.lensColor,
          },
        );
      }

      // Update the product card with the first swatch data
      const variantData = {
        variantId: firstSwatch.dataset.variantId,
        frameColor: firstSwatch.dataset.frameColor,
        lensColor: firstSwatch.dataset.lensColor,
        frameSize: firstSwatch.dataset.frameSize,
        available: firstSwatch.dataset.available === "true",
        price: parseInt(firstSwatch.dataset.price),
        comparePrice: firstSwatch.dataset.comparePrice
          ? parseInt(firstSwatch.dataset.comparePrice)
          : null,
        featuredImageUrl: firstSwatch.dataset.featuredImage,
      };

      // Update the product card display with first swatch data
      updateMultiSkuProductCard(productCard, variantData);

      if (CATALOG_DEBUG) {
        console.log(
          `[CATALOG_DEBUG] Card ${
            index + 1
          }: Initialized with first swatch data`,
          variantData,
        );
      }
    } else {
      if (CATALOG_DEBUG) {
        console.warn(`[CATALOG_DEBUG] Card ${index + 1}: No swatches found`);
      }
    }
  });
}

function handleSwatchClicks() {
  const swatches = document.querySelectorAll(
    ".catalog-section__product-card-swatch",
  );

  if (!swatches || swatches.length === 0) {
    if (CATALOG_DEBUG) console.log("No swatches found");
    return;
  }

  swatches.forEach((swatch) => {
    if (!swatch) return;

    swatch.addEventListener("click", function () {
      const productCard = this.closest(".catalog-section__product-card");
      if (!productCard) return;

      // Remove active class from all swatches in this card
      const cardSwatches = productCard.querySelectorAll(
        ".catalog-section__product-card-swatch",
      );
      cardSwatches.forEach((s) => s?.classList.remove("is-active"));

      // Add active class to clicked swatch
      this.classList.add("is-active");

      // Get variant data from the swatch
      const variantId = this.dataset.variantId;
      const frameColor = this.dataset.frameColor;
      const lensColor = this.dataset.lensColor;
      const frameSize = this.dataset.frameSize;
      const available = this.dataset.available === "true";
      const price = this.dataset.price;
      const comparePrice = this.dataset.comparePrice;
      const featuredImageUrl = this.dataset.featuredImage;

      if (CATALOG_DEBUG) {
        console.log("Swatch clicked:", {
          variantId,
          frameColor,
          lensColor,
          frameSize,
          available,
          price,
          featuredImageUrl,
        });
        console.log("Swatch dataset:", this.dataset);
        console.log(
          "data-featured-image attribute:",
          this.getAttribute("data-featured-image"),
        );
      }

      // Update the product card with new variant data
      updateMultiSkuProductCard(productCard, {
        variantId,
        frameColor,
        lensColor,
        frameSize,
        available,
        price,
        comparePrice,
        featuredImageUrl,
      });
    });
  });
}

function updateMultiSkuProductCard(productCard, variantData) {
  if (!productCard || !variantData) return;

  const {
    variantId,
    frameColor,
    lensColor,
    frameSize,
    available,
    price,
    comparePrice,
    featuredImageUrl,
  } = variantData;

  // Update the frame color and lens color display
  const frameColorSpan = productCard.querySelector("#frame-color");
  const lensColorSpan = productCard.querySelector("#lens-color");

  // Check for custom frame/lens colors (they override dynamic updates)
  const customFrameColor = productCard.dataset.customFrameColor;
  const customLensColor = productCard.dataset.customLensColor;

  if (frameColorSpan) {
    if (customFrameColor) {
      frameColorSpan.textContent = customFrameColor + ",";
    } else {
      frameColorSpan.textContent = frameColor + ",";
    }
  }

  if (lensColorSpan) {
    if (customLensColor) {
      lensColorSpan.textContent = " " + customLensColor;
    } else {
      lensColorSpan.textContent = " " + lensColor;
    }
  }

  // Update pricing
  const priceElement = productCard.querySelector(
    ".catalog-section__product-card-price-amount",
  );
  if (priceElement && price) {
    const formattedPrice = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(price / 100);
    priceElement.textContent = formattedPrice;
  }

  // Update compare at price if exists
  const comparePriceElement = productCard.querySelector(
    ".catalog-section__product-card-price-discount",
  );
  if (comparePriceElement && comparePrice && comparePrice > price) {
    const formattedComparePrice = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(comparePrice / 100);
    comparePriceElement.textContent = formattedComparePrice;
    comparePriceElement.style.display = "";
  } else if (comparePriceElement) {
    comparePriceElement.style.display = "none";
  }

  // Update add to cart button
  const addToCartButton = productCard.querySelector(
    ".catalog-section__product-card-add-to-cart-btn",
  );
  if (addToCartButton) {
    addToCartButton.setAttribute("data-variant-id", variantId);

    if (available) {
      addToCartButton.disabled = false;
      addToCartButton.textContent = "Add to Cart";
    } else {
      addToCartButton.disabled = true;
      addToCartButton.textContent = "Out of Stock";
    }
  }

  // Update main product image with the variant's featured image
  const mainImg = productCard.querySelector(".catalog-section--featured-image");

  if (CATALOG_DEBUG) {
    console.log("[CATALOG_DEBUG] Image update attempt:", {
      mainImg: !!mainImg,
      featuredImageUrl: featuredImageUrl,
      currentSrc: mainImg ? mainImg.src : "NO_IMG_ELEMENT",
    });
  }

  if (mainImg && featuredImageUrl) {
    // Convert relative URL to absolute URL if needed (for localhost development)
    let absoluteImageUrl = featuredImageUrl;
    if (
      featuredImageUrl.startsWith("/") &&
      !featuredImageUrl.startsWith("//")
    ) {
      // Get the current origin (protocol + hostname + port)
      absoluteImageUrl = window.location.origin + featuredImageUrl;
    }

    if (CATALOG_DEBUG) {
      console.log("[CATALOG_DEBUG] URL conversion:", {
        original: featuredImageUrl,
        absolute: absoluteImageUrl,
        currentOrigin: window.location.origin,
      });
    }

    // Add smooth transition effect
    mainImg.style.opacity = "0.7";

    // Load new image
    const newImg = new Image();
    newImg.onload = function () {
      mainImg.src = absoluteImageUrl;

      // Clear srcset to force browser to use the new src
      // The srcset contains old image URLs that override our new src
      mainImg.removeAttribute("srcset");

      mainImg.style.opacity = "1";

      if (CATALOG_DEBUG) {
        console.log(
          "[CATALOG_DEBUG] Image successfully updated to:",
          absoluteImageUrl,
        );
        console.log(
          "[CATALOG_DEBUG] Removed srcset attribute to force new image",
        );
      }

      // Also update alt text for accessibility
      if (frameColor && lensColor) {
        mainImg.alt = `${frameColor} ${lensColor} sunglasses`;
      }
    };

    newImg.onerror = function () {
      if (CATALOG_DEBUG) {
        console.error(
          "[CATALOG_DEBUG] Failed to load image:",
          absoluteImageUrl,
        );
      }
      // Reset opacity even if image fails to load
      mainImg.style.opacity = "1";
    };

    newImg.src = absoluteImageUrl;

    if (CATALOG_DEBUG) {
      console.log(
        "[CATALOG_DEBUG] Started loading new image:",
        absoluteImageUrl,
      );
    }
  } else {
    if (CATALOG_DEBUG) {
      console.warn(
        "[CATALOG_DEBUG] Image update skipped - missing element or URL:",
        {
          hasMainImg: !!mainImg,
          hasFeaturedImageUrl: !!featuredImageUrl,
        },
      );
    }
  }

  // Update the stored current swatch variant
  productCard.setAttribute("data-current-swatch-variant", variantId);

  // Update product links with new variant
  const baseUrl = productCard
    .querySelector(".catalog-section__product-card-image")
    ?.getAttribute("data-base-url");
  if (baseUrl && variantId) {
    let newUrl = `${baseUrl}?variant=${variantId}`;

    // Add frame_size parameter
    newUrl = addFrameSizeToUrl(newUrl, productCard);

    // Check if variant is EOL - get SKU from active swatch
    const activeSwatch = productCard.querySelector(
      ".catalog-section__product-card-swatch.is-active",
    );
    const variantSku = activeSwatch?.dataset?.sku;
    const isVariantEOL = variantSku && EOL_SKUS.includes(String(variantSku));

    // Update image link - disable if EOL
    const imageLink = productCard.querySelector(
      ".catalog-section__product-card-image-link",
    );
    if (imageLink) {
      if (isVariantEOL) {
        // Convert anchor to disabled div if EOL (only if it's still an anchor)
        if (imageLink.href !== undefined) {
          const imageContent = imageLink.innerHTML;
          const newDiv = document.createElement("div");
          newDiv.className =
            "catalog-section__product-card-image-link catalog-section__product-card-image-link--disabled";
          newDiv.style.cssText = "pointer-events: none; cursor: default;";
          newDiv.innerHTML = imageContent;
          imageLink.parentNode.replaceChild(newDiv, imageLink);
        }
      } else {
        // Update href for non-EOL variants (restore if it was converted to div)
        if (imageLink.href !== undefined) {
          imageLink.href = newUrl;
        } else if (
          imageLink.classList.contains(
            "catalog-section__product-card-image-link--disabled",
          )
        ) {
          // Restore from disabled div to anchor
          const imageContent = imageLink.innerHTML;
          const newAnchor = document.createElement("a");
          newAnchor.className = "catalog-section__product-card-image-link";
          newAnchor.href = newUrl;
          newAnchor.innerHTML = imageContent;
          imageLink.parentNode.replaceChild(newAnchor, imageLink);
        }
      }
    }

    // Update review link - disable if EOL
    const reviewLink = productCard.querySelector(
      ".catalog-section__product-card-header-review-link",
    );
    if (reviewLink) {
      if (isVariantEOL) {
        // Convert anchor to disabled div if EOL (only if it's still an anchor)
        if (reviewLink.href !== undefined) {
          const reviewContent = reviewLink.innerHTML;
          const newDiv = document.createElement("div");
          newDiv.className = "catalog-section__product-card-header-review-link";
          newDiv.style.cssText = "pointer-events: none; cursor: default;";
          newDiv.innerHTML = reviewContent;
          reviewLink.parentNode.replaceChild(newDiv, reviewLink);
        }
      } else {
        // Update href for non-EOL variants (restore if it was converted to div)
        if (reviewLink.href !== undefined) {
          reviewLink.href = `${newUrl}#pdp-review-section`;
        } else {
          // Restore from disabled div to anchor
          const reviewContent = reviewLink.innerHTML;
          const newAnchor = document.createElement("a");
          newAnchor.className =
            "catalog-section__product-card-header-review-link";
          newAnchor.href = `${newUrl}#pdp-review-section`;
          newAnchor.role = "link";
          newAnchor.innerHTML = reviewContent;
          reviewLink.parentNode.replaceChild(newAnchor, reviewLink);
        }
      }
    }

    // Update any other product links
    const allProductLinks = productCard.querySelectorAll(
      'a[href*="/products/"]',
    );
    allProductLinks.forEach((link) => {
      if (link && link.href && link.href.includes(baseUrl.split("?")[0])) {
        const hash = link.href.includes("#") ? link.href.split("#")[1] : "";
        link.href = hash ? `${newUrl}#${hash}` : newUrl;
      }
    });
  }

  if (CATALOG_DEBUG) {
    console.log(
      "[CATALOG_DEBUG] Updated multi-sku product card for variant:",
      variantId,
    );
  }

  // Update frame size buttons with correct variant IDs for current swatch
  updateFrameSizeButtons(productCard);

  // Re-update product state to ensure price/links reflect the currently active frame size
  // (e.g. if XL was selected, we want to show the new color's XL price, not the default swatch price)
  updateCatalogProductState(productCard);
}

function updateFrameSizeButtons(productCard) {
  const frameSizeButtons = productCard.querySelectorAll(
    ".catalog-section__product-card-frame-size-btn",
  );

  if (!frameSizeButtons || frameSizeButtons.length === 0) return;

  // Get the active swatch to retrieve frame size variant data
  const activeSwatch = productCard.querySelector(
    ".catalog-section__product-card-swatch.is-active",
  );

  if (activeSwatch) {
    if (CATALOG_DEBUG) {
      console.log(
        "[CATALOG_DEBUG] Updating frame size buttons using active swatch data:",
        {
          frameColor: activeSwatch.dataset.frameColor,
          lensColor: activeSwatch.dataset.lensColor,
          regularId: activeSwatch.dataset.regularId,
          narrowId: activeSwatch.dataset.narrowId,
          xlId: activeSwatch.dataset.xlId,
          regularAvailable: activeSwatch.dataset.regularAvailable,
          narrowAvailable: activeSwatch.dataset.narrowAvailable,
          xlAvailable: activeSwatch.dataset.xlAvailable,
        },
      );
    }

    frameSizeButtons.forEach((frameSizeBtn) => {
      const targetFrameSize = frameSizeBtn.dataset.frameSize;
      let targetVariantId = null;
      let targetAvailable = false;
      let targetPrice = null;
      let targetComparePrice = null;

      if (CATALOG_DEBUG) {
        console.log(
          `[CATALOG_DEBUG] Processing frame size button: "${targetFrameSize}"`,
        );
      }

      // Map frame size to the correct variant ID from swatch data
      if (targetFrameSize === "Regular") {
        targetVariantId = activeSwatch.dataset.regularId;
        targetAvailable = activeSwatch.dataset.regularAvailable === "true";
        targetPrice = activeSwatch.dataset.regularPrice;
        targetComparePrice = activeSwatch.dataset.regularComparePrice;
      } else if (targetFrameSize === "Narrow") {
        targetVariantId = activeSwatch.dataset.narrowId;
        targetAvailable = activeSwatch.dataset.narrowAvailable === "true";
        targetPrice = activeSwatch.dataset.narrowPrice;
        targetComparePrice = activeSwatch.dataset.narrowComparePrice;
      } else if (targetFrameSize === "XL") {
        targetVariantId = activeSwatch.dataset.xlId;
        targetAvailable = activeSwatch.dataset.xlAvailable === "true";
        targetPrice = activeSwatch.dataset.xlPrice;
        targetComparePrice = activeSwatch.dataset.xlComparePrice;
      }

      if (targetVariantId) {
        const oldVariantId = frameSizeBtn.getAttribute("data-variant-id");
        frameSizeBtn.setAttribute("data-variant-id", targetVariantId);
        frameSizeBtn.setAttribute("data-available", targetAvailable);

        // Update price attributes if available
        if (targetPrice) {
          frameSizeBtn.setAttribute("data-variant-price", targetPrice);
        }
        if (targetComparePrice) {
          frameSizeBtn.setAttribute(
            "data-variant-compare-price",
            targetComparePrice,
          );
        }

        // Check if this variant is EOL by checking SKU
        const variantSku = frameSizeBtn.dataset.sku;
        const isEOL = variantSku && EOL_SKUS.includes(String(variantSku));

        if (isEOL) {
          // Hide EOL variants (like PDP does)
          frameSizeBtn.classList.add("hidden");
        } else {
          // Show non-EOL variants
          frameSizeBtn.classList.remove("hidden");
          frameSizeBtn.disabled = false;
          frameSizeBtn.style.display = ""; // Make sure button is visible
          frameSizeBtn.style.visibility = "visible"; // Set visibility for CSS width rule
        }

        if (CATALOG_DEBUG) {
          console.log(
            `[CATALOG_DEBUG] ✅ Updated frame size button "${targetFrameSize}":`,
            {
              oldVariantId,
              newVariantId: targetVariantId,
              available: targetAvailable,
              price: targetPrice,
              comparePrice: targetComparePrice,
              sku: variantSku,
              isEOL,
              disabled: false, // Always clickable
            },
          );
        }
      } else {
        // If no variant ID exists for this frame size, hide the button
        if (CATALOG_DEBUG) {
          console.warn(
            `[CATALOG_DEBUG] ❌ No variant ID found for frame size "${targetFrameSize}" - button will be hidden`,
          );
        }
        frameSizeBtn.classList.add("hidden");
      }
    });
  } else {
    if (CATALOG_DEBUG) {
      console.warn("[CATALOG_DEBUG] No active swatch found");
    }
  }
}

function handleFilterTabs() {
  const sections = document.querySelectorAll(".catalog-section");

  sections.forEach((section) => {
    if (!section) return;

    const filterContainer = section.querySelector(
      ".catalog-section__filter-tabs",
    );
    const filterTabs = section.querySelectorAll(".catalog-section__filter-tab");
    const headerContainer = section.querySelector(".catalog-section__header");

    // Check if no filter tabs exist
    if (!filterContainer || !filterTabs || filterTabs.length === 0) {
      if (CATALOG_DEBUG) console.log("No filter tabs found in section");

      // If no filter tabs AND no header, show all products
      if (!headerContainer) {
        showAllProducts(section);
        if (CATALOG_DEBUG)
          console.log("No header or filter tabs - showing all products");
        return;
      }

      // If header exists but no filter tabs, still show all products
      showAllProducts(section);
      if (CATALOG_DEBUG)
        console.log("Header exists but no filter tabs - showing all products");
      return;
    }

    // Get available filter types for this section
    const availableFilters = [];
    filterTabs.forEach((tab) => {
      if (!tab) return;

      const filterType =
        tab.getAttribute("data-filter") ||
        tab.textContent?.toLowerCase()?.trim();
      if (filterType) {
        let normalizedFilter = filterType;
        if (filterType.includes("polarized") && !filterType.includes("non")) {
          normalizedFilter = "polarized";
        } else if (filterType.includes("non-polarized")) {
          normalizedFilter = "non-polarized";
        } else if (
          filterType.includes("low light") ||
          filterType.includes("blue-blocking")
        ) {
          normalizedFilter = "low-light";
        }
        availableFilters.push(normalizedFilter);
        tab.setAttribute("data-filter", normalizedFilter);
      }
    });

    if (CATALOG_DEBUG) console.log("Available filters:", availableFilters);

    // If no valid filters found, show all products
    if (availableFilters.length === 0) {
      showAllProducts(section);
      if (CATALOG_DEBUG)
        console.log("No valid filters found - showing all products");
      return;
    }

    // Add click events for filter tabs
    filterTabs.forEach((tab) => {
      if (!tab) return;

      tab.addEventListener("click", function () {
        const filterType = this.getAttribute("data-filter");
        if (!filterType) return;

        // Update active tab within this section only
        const currentSectionTabs = section.querySelectorAll(
          ".catalog-section__filter-tab",
        );
        currentSectionTabs.forEach((t) => {
          if (t) t.classList.remove("catalog-section__filter-tab--active");
        });
        this.classList.add("catalog-section__filter-tab--active");

        // Filter products only in this section
        filterProducts(filterType, section);
      });
    });

    // Set polarized as default filter and apply it
    const polarizedTab = section.querySelector('[data-filter="polarized"]');
    if (polarizedTab) {
      // Remove any existing active states
      filterTabs.forEach((t) => {
        if (t) t.classList.remove("catalog-section__filter-tab--active");
      });
      // Set polarized as active and apply the filter
      polarizedTab.classList.add("catalog-section__filter-tab--active");
      filterProducts("polarized", section);
    } else if (availableFilters.length > 0) {
      // Fallback to first available filter if no polarized found
      const firstTab = section.querySelector(
        `[data-filter="${availableFilters[0]}"]`,
      );
      if (firstTab) {
        filterTabs.forEach((t) => {
          if (t) t.classList.remove("catalog-section__filter-tab--active");
        });
        firstTab.classList.add("catalog-section__filter-tab--active");
        filterProducts(availableFilters[0], section);
      }
    }

    if (CATALOG_DEBUG) {
      console.log(
        "Filter tabs initialized - polarized tab active and filter applied",
      );
    }
  });
}

// Helper function to show all products in a section
function showAllProducts(section = null) {
  const targetScope = section || document;
  const productCards = targetScope.querySelectorAll(
    ".catalog-section__product-grid-item",
  );

  if (!productCards || productCards.length === 0) return;

  let visibleCount = 0;
  productCards.forEach((card) => {
    if (!card) return;

    // Never show cards where all variants are EOL
    const allVariantsEOL =
      card.getAttribute("data-all-variants-eol") === "true";
    if (allVariantsEOL) {
      card.style.display = "none";
      card.classList.add("hidden");
      return;
    }

    card.style.display = "";
    card.classList.remove("hidden");
    visibleCount++;
  });

  if (CATALOG_DEBUG)
    console.log(`Showing all products: ${visibleCount} visible cards`);
}

function filterProducts(filterType, section = null) {
  // If no section provided, use global scope
  const targetScope = section || document;
  const productCards = targetScope.querySelectorAll(
    ".catalog-section__product-grid-item",
  );

  if (!filterType || !productCards || productCards.length === 0) return;

  if (CATALOG_DEBUG)
    console.log(
      "Filtering products by:",
      filterType,
      "in section:",
      section ? "specific" : "global",
    );

  let visibleCount = 0;
  productCards.forEach((card) => {
    if (!card) return;

    // Never show cards where all variants are EOL, regardless of filter
    const allVariantsEOL =
      card.getAttribute("data-all-variants-eol") === "true";
    if (allVariantsEOL) {
      card.style.display = "none";
      card.classList.add("hidden");
      return;
    }

    let shouldShow = false;
    if (filterType === "polarized") {
      shouldShow = card.getAttribute("data-is-polarized-item") === "true";
    } else if (filterType === "non-polarized") {
      shouldShow = card.getAttribute("data-is-non-polarized-item") === "true";
    } else if (filterType === "low-light") {
      shouldShow = card.getAttribute("data-is-low-light-item") === "true";
    }

    if (shouldShow) {
      card.style.display = "";
      card.classList.remove("hidden");
      visibleCount++;
    } else {
      card.style.display = "none";
      card.classList.add("hidden");
    }
  });

  if (CATALOG_DEBUG)
    console.log(`Filtered results: ${visibleCount} visible cards`);

  // Recheck review counts for newly visible cards after filtering
  setTimeout(() => {
    if (
      window.handleCatalogKlaviyoReviewCountsUpdate &&
      typeof window.handleCatalogKlaviyoReviewCountsUpdate === "function"
    ) {
      window.handleCatalogKlaviyoReviewCountsUpdate();
    }
  }, 100);
}

function handleFrameSizeClicks() {
  // Handle frame size button clicks
  const frameSizeButtons = document.querySelectorAll(
    ".catalog-section__product-card-frame-size-btn",
  );

  if (!frameSizeButtons || frameSizeButtons.length === 0) {
    if (CATALOG_DEBUG) console.log("No frame size buttons found");
    return;
  }

  frameSizeButtons.forEach((button) => {
    if (!button) return;

    button.addEventListener("click", function () {
      const card = this.closest(".catalog-section__product-card");
      if (!card) return;

      const cardButtons = card.querySelectorAll(
        ".catalog-section__product-card-frame-size-btn",
      );

      // Remove active class from all buttons in this card
      cardButtons.forEach((btn) => {
        if (!btn) return;
        btn.classList.remove("is-active");
        btn.setAttribute("aria-pressed", "false");
      });

      // Add active class to clicked button
      this.classList.add("is-active");
      this.setAttribute("aria-pressed", "true");

      // Update product state (variant ID, image links, etc)
      updateCatalogProductState(card);

      const selectedFrameSize = this.dataset?.frameSize;
      const selectedVariantId = this.dataset?.variantId;
      if (CATALOG_DEBUG)
        console.log(
          "Selected frame size:",
          selectedFrameSize,
          "Variant ID:",
          selectedVariantId,
        );
    });
  });
}

function updateCatalogProductState(productCard) {
  if (!productCard) return;

  const selectedButton = productCard.querySelector(
    ".catalog-section__product-card-frame-size-btn.is-active",
  );
  const addToCartButton = productCard.querySelector(
    ".catalog-section__product-card-add-to-cart-btn",
  );
  const imageWrapper = productCard.querySelector(
    ".catalog-section__product-card-image",
  );
  const reviewLink = productCard.querySelector(
    ".catalog-section__product-card-header-review-link",
  );

  if (!selectedButton) return;

  const variantId = selectedButton.dataset?.variantId;
  const frameSize = selectedButton.dataset?.frameSize;
  const isAvailable = selectedButton.dataset?.available === "true";
  const hasNoVariant = selectedButton.dataset?.noVariant === "true";
  const baseUrl = imageWrapper?.getAttribute("data-base-url");

  if (CATALOG_DEBUG) {
    console.log("[CATALOG_DEBUG] Selected button data:", {
      frameSize,
      variantId,
      isAvailable,
      hasNoVariant,
      buttonDataset: selectedButton.dataset,
    });
  }

  // If button has no variant, disable add to cart
  if (hasNoVariant || !variantId) {
    if (addToCartButton) {
      addToCartButton.disabled = true;
      addToCartButton.textContent = "Unavailable";
    }
    if (CATALOG_DEBUG) {
      console.warn(
        "[CATALOG_DEBUG] Frame size button has no variant ID - disabling add to cart",
      );
    }
    return;
  }

  // Get product grid and check if bundle FIRST (before using these variables)
  const productGrid = productCard.closest(
    ".catalog-section__product-grid-item",
  );
  const isBundle = productGrid?.querySelector("[data-is-bundle='true']");
  const isMultiSku = productCard.querySelector("[data-multi-sku-variants]");

  if (CATALOG_DEBUG) {
    console.log("[CATALOG_DEBUG] updateCatalogProductState:", {
      frameSize,
      variantId,
      isAvailable,
      isBundle: !!isBundle,
      isMultiSku: !!isMultiSku,
    });
  }

  // Update add to cart button based on availability
  if (addToCartButton && variantId) {
    addToCartButton.setAttribute("data-variant-id", variantId);

    if (isAvailable) {
      addToCartButton.disabled = false;
      addToCartButton.textContent = "Add to Cart";
    } else {
      addToCartButton.disabled = true;
      addToCartButton.textContent = "Out of Stock";
    }
  }

  // Update pricing when frame size changes (for all product types)

  if (variantId) {
    if (isBundle) {
      // Handle bundle pricing calculation
      updateBundlePricing(productCard, variantId);
    } else {
      // Handle regular pricing update for single_sku, single_sku_tagline, and multi_sku
      updateRegularPricing(productCard, selectedButton);

      // For multi-sku products, also update frame/lens color display when frame size changes
      if (isMultiSku) {
        updateMultiSkuDisplayForFrameSize(productCard, variantId);
      }
    }
  }

  // Update all product links with selected variant parameter
  if (baseUrl && variantId) {
    // Check if this is a kit product and build addon URL
    const productGrid = productCard.closest(
      ".catalog-section__product-grid-item",
    );
    const productHandle =
      productGrid?.dataset?.productHandle?.toLowerCase() || "";
    const isKit = productGrid?.querySelector("[data-is-bundle='true']");

    let newUrl = `${baseUrl}?variant=${variantId}`;

    // Add addons for kit products
    if (isKit) {
      const addons = [];
      const sideshieldId = addToCartButton?.dataset?.sideshieldId;
      const riserId = addToCartButton?.dataset?.riserId;
      const floatieId = addToCartButton?.dataset?.floatieId;

      // Determine if this product should use the nose shield addon
      const isRefugio = productHandle.includes("refugio");

      // Add appropriate addons
      if (sideshieldId) addons.push("sideshields");
      if (riserId) addons.push(isRefugio ? "noseshield" : "riser");
      if (floatieId) addons.push("floatie");

      if (addons.length > 0) {
        newUrl += `&addons=${addons.join(",")}`;
      }

      if (CATALOG_DEBUG) {
        console.log(
          "[CATALOG_DEBUG] Kit URL with addons:",
          newUrl,
          "Addons:",
          addons,
          "IsRefugio:",
          isRefugio,
        );
      }
    }

    // Add frame_size parameter
    newUrl = addFrameSizeToUrl(newUrl, productCard);

    // Check if selected variant is EOL
    const variantSku = selectedButton?.dataset?.sku;
    const isVariantEOL = variantSku && EOL_SKUS.includes(String(variantSku));

    // Update image link - disable if EOL
    const imageLink = imageWrapper?.querySelector(
      ".catalog-section__product-card-image-link",
    );
    if (imageLink) {
      if (isVariantEOL) {
        // Convert anchor to disabled div if EOL (only if it's still an anchor)
        if (imageLink.href !== undefined) {
          const imageContent = imageLink.innerHTML;
          const newDiv = document.createElement("div");
          newDiv.className =
            "catalog-section__product-card-image-link catalog-section__product-card-image-link--disabled";
          newDiv.style.cssText = "pointer-events: none; cursor: default;";
          newDiv.innerHTML = imageContent;
          imageLink.parentNode.replaceChild(newDiv, imageLink);
        }
      } else {
        // Update href for non-EOL variants (restore if it was converted to div)
        if (imageLink.href !== undefined) {
          imageLink.href = newUrl;
        } else if (
          imageLink.classList.contains(
            "catalog-section__product-card-image-link--disabled",
          )
        ) {
          // Restore from disabled div to anchor
          const imageContent = imageLink.innerHTML;
          const newAnchor = document.createElement("a");
          newAnchor.className = "catalog-section__product-card-image-link";
          newAnchor.href = newUrl;
          newAnchor.innerHTML = imageContent;
          imageLink.parentNode.replaceChild(newAnchor, imageLink);
        }
      }
    }

    // Update review link - disable if EOL
    if (reviewLink) {
      if (isVariantEOL) {
        // Convert anchor to disabled div if EOL (only if it's still an anchor)
        if (reviewLink.href !== undefined) {
          const reviewContent = reviewLink.innerHTML;
          const newDiv = document.createElement("div");
          newDiv.className = "catalog-section__product-card-header-review-link";
          newDiv.style.cssText = "pointer-events: none; cursor: default;";
          newDiv.innerHTML = reviewContent;
          reviewLink.parentNode.replaceChild(newDiv, reviewLink);
        }
      } else {
        // Update href for non-EOL variants (restore if it was converted to div)
        if (reviewLink.href !== undefined) {
          reviewLink.href = `${newUrl}#pdp-review-section`;
        } else {
          // Restore from disabled div to anchor
          const reviewContent = reviewLink.innerHTML;
          const newAnchor = document.createElement("a");
          newAnchor.className =
            "catalog-section__product-card-header-review-link";
          newAnchor.href = `${newUrl}#pdp-review-section`;
          newAnchor.role = "link";
          newAnchor.innerHTML = reviewContent;
          reviewLink.parentNode.replaceChild(newAnchor, reviewLink);
        }
      }
    }

    // Update any other product links in the card
    const allProductLinks = productCard.querySelectorAll(
      'a[href*="/products/"]',
    );
    if (allProductLinks && allProductLinks.length > 0) {
      allProductLinks.forEach((link) => {
        if (!link || !link.href) return;

        if (link.href.includes(baseUrl.split("?")[0])) {
          const hash = link.href.includes("#") ? link.href.split("#")[1] : "";
          link.href = hash ? `${newUrl}#${hash}` : newUrl;
        }
      });
    }
  }

  if (CATALOG_DEBUG) {
    console.log("[CATALOG_DEBUG] Updated product state:", {
      frameSize,
      variantId,
      isAvailable,
      newUrl:
        baseUrl && variantId ? `${baseUrl}?variant=${variantId}` : baseUrl,
    });
  }
}

async function updateBundlePricing(productCard, newVariantId) {
  if (!productCard || !newVariantId) return;

  const selectedFrameButton = productCard.querySelector(
    ".catalog-section__product-card-frame-size-btn.is-active",
  );
  if (!selectedFrameButton) return;

  // Get main variant price from button data attributes
  const mainPrice = Number.parseInt(
    selectedFrameButton.dataset.variantPrice,
    10,
  );
  const variantComparePrice = Number.parseInt(
    selectedFrameButton.dataset.variantComparePrice || "0",
    10,
  );

  if (!mainPrice) {
    if (CATALOG_DEBUG) {
      console.warn("[CATALOG_DEBUG] No variant price data available");
    }
    return;
  }

  // Pull static kit pricing totals calculated in Liquid so variant swaps stay accurate
  const kitItemsTotalRaw = Number.parseInt(
    productCard.dataset.kitPriceTotal || "0",
    10,
  );
  const kitItemsTotal = Number.isNaN(kitItemsTotalRaw) ? 0 : kitItemsTotalRaw;

  const kitCompareTotalRaw = Number.parseInt(
    productCard.dataset.kitCompareTotal || "0",
    10,
  );
  const kitCompareTotal = Number.isNaN(kitCompareTotalRaw)
    ? 0
    : kitCompareTotalRaw;

  const effectiveMainCompare =
    variantComparePrice && variantComparePrice > mainPrice
      ? variantComparePrice
      : mainPrice;

  const bundlePrice = mainPrice + kitItemsTotal;
  const bundleComparePrice = effectiveMainCompare + kitCompareTotal;

  // Clean up legacy cached price element if present
  const legacyOriginalPrice = productCard.querySelector(
    "[data-original-main-price]",
  );
  if (legacyOriginalPrice) {
    legacyOriginalPrice.remove();
  }

  // Update price display
  const priceElement = productCard.querySelector(
    ".catalog-section__product-card-price-amount",
  );
  const comparePriceElement = productCard.querySelector(
    ".catalog-section__product-card-price-discount",
  );

  if (priceElement) {
    const formattedPrice = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(bundlePrice / 100);
    priceElement.textContent = formattedPrice;
  }

  if (comparePriceElement) {
    if (bundleComparePrice > bundlePrice) {
      const formattedComparePrice = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(bundleComparePrice / 100);
      comparePriceElement.textContent = formattedComparePrice;
      comparePriceElement.style.display = "";
    } else {
      comparePriceElement.style.display = "none";
    }
  }

  if (CATALOG_DEBUG) {
    console.log("[CATALOG_DEBUG] Updated bundle pricing:", {
      mainVariant: newVariantId,
      mainPrice: mainPrice / 100,
      kitItemsTotal: kitItemsTotal / 100,
      bundlePrice: bundlePrice / 100,
      bundleComparePrice: bundleComparePrice / 100,
    });
  }
}

function updateRegularPricing(productCard, selectedButton) {
  if (!productCard || !selectedButton) return;

  // Get variant price from button data attributes
  const variantPrice = parseInt(selectedButton.dataset.variantPrice);
  const variantComparePrice =
    parseInt(selectedButton.dataset.variantComparePrice) || 0;

  if (!variantPrice) {
    if (CATALOG_DEBUG)
      console.warn(
        "[CATALOG_DEBUG] No variant price data available for regular pricing update",
      );
    return;
  }

  // Update price display
  const priceElement = productCard.querySelector(
    ".catalog-section__product-card-price-amount",
  );
  const comparePriceElement = productCard.querySelector(
    ".catalog-section__product-card-price-discount",
  );

  if (priceElement) {
    const formattedPrice = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(variantPrice / 100);
    priceElement.textContent = formattedPrice;
  }

  if (comparePriceElement) {
    if (variantComparePrice > variantPrice) {
      const formattedComparePrice = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(variantComparePrice / 100);
      comparePriceElement.textContent = formattedComparePrice;
      comparePriceElement.style.display = "";
    } else {
      comparePriceElement.style.display = "none";
    }
  }

  if (CATALOG_DEBUG) {
    console.log("[CATALOG_DEBUG] Updated regular pricing:", {
      variantId: selectedButton.dataset.variantId,
      frameSize: selectedButton.dataset.frameSize,
      price: variantPrice / 100,
      comparePrice: variantComparePrice / 100,
    });
  }
}

function updateMultiSkuDisplayForFrameSize(productCard, newVariantId) {
  if (!productCard || !newVariantId) return;

  // Find the swatch that matches the new variant ID
  const swatches = productCard.querySelectorAll(
    ".catalog-section__product-card-swatch",
  );
  let matchingSwatch = null;

  swatches.forEach((swatch) => {
    // Check if this swatch has the matching variant for the selected frame size
    const regularId = swatch.dataset.regularId;
    const narrowId = swatch.dataset.narrowId;
    const xlId = swatch.dataset.xlId;

    if (
      regularId == newVariantId ||
      narrowId == newVariantId ||
      xlId == newVariantId
    ) {
      matchingSwatch = swatch;
    }
  });

  if (matchingSwatch) {
    // Update frame and lens color display (respect custom colors)
    const frameColorSpan = productCard.querySelector("#frame-color");
    const lensColorSpan = productCard.querySelector("#lens-color");

    // Check for custom frame/lens colors (they override dynamic updates)
    const customFrameColor = productCard.dataset.customFrameColor;
    const customLensColor = productCard.dataset.customLensColor;

    if (frameColorSpan) {
      if (customFrameColor) {
        frameColorSpan.textContent = customFrameColor + ",";
      } else {
        frameColorSpan.textContent = matchingSwatch.dataset.frameColor + ",";
      }
    }

    if (lensColorSpan) {
      if (customLensColor) {
        lensColorSpan.textContent = " " + customLensColor;
      } else {
        lensColorSpan.textContent = " " + matchingSwatch.dataset.lensColor;
      }
    }

    if (CATALOG_DEBUG) {
      console.log(
        "[CATALOG_DEBUG] Updated multi-sku display for frame size change:",
        {
          newVariantId,
          frameColor: matchingSwatch.dataset.frameColor,
          lensColor: matchingSwatch.dataset.lensColor,
        },
      );
    }
  }
}

function handleKlaviyoReviewCounts() {
  let updateAttempts = 0;
  const maxAttempts = 15;
  let updatedCards = new Set();

  function updateReviewCounts() {
    const productCards = document.querySelectorAll(
      ".catalog-section__product-card:not(.hidden)",
    );
    if (!productCards.length) return;

    productCards.forEach((card, index) => {
      const cardId = `catalog-card-${index}`;
      if (updatedCards.has(cardId)) return;

      const klaviyoLabel = card.querySelector(
        ".kl_reviews__star_rating_widget__label",
      );
      const customReviewCount = card.querySelector(
        ".catalog-section__review-count",
      );
      const klaviyoWrapper = card.querySelector(".klaviyo-star-rating-wrapper");

      if (klaviyoLabel && customReviewCount) {
        const reviewText = klaviyoLabel.textContent.trim();
        const reviewCount = reviewText.match(/[\d,]+/);

        if (reviewCount && reviewCount[0] !== "0") {
          // Remove any existing commas and parse as integer
          const cleanNumber = parseInt(reviewCount[0].replace(/,/g, ""));

          // Format the number with commas for thousands separator
          const formattedCount = cleanNumber.toLocaleString("en-US");

          customReviewCount.textContent = `(${formattedCount})`;
          if (klaviyoWrapper) klaviyoWrapper.style.display = "none";
          updatedCards.add(cardId);

          if (CATALOG_DEBUG) {
            console.log(
              `Updated catalog card ${index} with count: ${formattedCount}`,
            );
          }
        }
      }
    });

    updateAttempts++;

    if (
      updateAttempts < maxAttempts &&
      updatedCards.size < productCards.length
    ) {
      const delay = Math.min(500 + updateAttempts * 200, 3000);
      setTimeout(updateReviewCounts, delay);
    }
  }

  // Start updates
  updateReviewCounts();

  // Fallback for remaining cards after 10 seconds
  setTimeout(() => {
    const productCards = document.querySelectorAll(
      ".catalog-section__product-card:not(.hidden)",
    );
    productCards.forEach((card, index) => {
      const cardId = `catalog-card-${index}`;
      if (!updatedCards.has(cardId)) {
        const customReviewCount = card.querySelector(
          ".catalog-section__review-count",
        );
        const klaviyoWrapper = card.querySelector(
          ".klaviyo-star-rating-wrapper",
        );

        if (customReviewCount) {
          customReviewCount.textContent = "(1,000+)";
          if (klaviyoWrapper) klaviyoWrapper.style.display = "none";
        }
      }
    });
  }, 10000);

  // Expose update function globally for catalog section
  window.handleCatalogKlaviyoReviewCountsUpdate = updateReviewCounts;
}

// Handle add to cart functionality for catalog section
function handleAddToCart() {
  function handleAddToCartClick(event) {
    if (!event || !event.target) return;

    // Prevent all default behaviors and event propagation
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const button = event.target;

    // Check if button is already processing
    if (button.disabled || button.classList.contains("processing")) {
      console.log("[CATALOG_DEBUG] Button already processing, ignoring click");
      return;
    }

    const productCard = button.closest(".catalog-section__product-card");

    if (!productCard) {
      console.error("[CATALOG_DEBUG] Could not find product card");
      return;
    }

    // Mark button as processing to prevent double clicks
    button.classList.add("processing");

    // Check if this is a bundle product (kit)
    const isBundle =
      button.dataset?.sideshieldId ||
      button.dataset?.riserId ||
      button.dataset?.floatieId;

    console.log("[CATALOG_DEBUG] Button dataset:", button.dataset);
    console.log("[CATALOG_DEBUG] Is bundle detected:", isBundle);

    if (isBundle) {
      handleBundleAddToCart(button, productCard);
    } else {
      handleSingleAddToCart(button, productCard);
    }
  }

  function handleSingleAddToCart(button, productCard) {
    const selectedFrameSize = productCard.querySelector(
      ".catalog-section__product-card-frame-size-btn.is-active",
    );
    let variantId;

    console.log("[CATALOG_DEBUG] Selected frame button:", selectedFrameSize);
    console.log(
      "[CATALOG_DEBUG] Button data-variant-id:",
      button.getAttribute("data-variant-id"),
    );

    if (selectedFrameSize) {
      variantId = selectedFrameSize.dataset?.variantId;
      const isAvailable = selectedFrameSize.dataset?.available === "true";

      console.log(
        "[CATALOG_DEBUG] Using selected frame variant:",
        variantId,
        "Available:",
        isAvailable,
      );

      if (!isAvailable) {
        button.disabled = true;
        button.textContent = "Out of Stock";
        return;
      }
    } else {
      variantId = button.getAttribute("data-variant-id");
      console.log(
        "[CATALOG_DEBUG] No selected frame, using button variant:",
        variantId,
      );
    }

    if (!variantId) {
      console.error("[CATALOG_DEBUG] No variant ID found");
      return;
    }

    console.log(
      "[CATALOG_DEBUG] Adding single product - Variant ID:",
      variantId,
    );

    // Update button state to loading
    const originalText = button.textContent || "Add to Cart";
    button.textContent = "Adding Item...";
    button.disabled = true;

    // Add to cart using FormData (same as bestsellers)
    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.json();
      })
      .then((data) => {
        if (CATALOG_DEBUG) {
          console.log("[CATALOG_DEBUG] Item added to cart:", data);
        }

        // Clear any stored errors on success
        localStorage.removeItem("catalog_last_error");

        // Remove processing class
        button.classList.remove("processing");

        // Handle success like bestsellers
        handleCatalogCartSuccess(button, originalText);
      })
      .catch((error) => {
        console.error("[CATALOG_DEBUG] Error adding to cart:", error);

        // Store error in localStorage for debugging page reloads
        const errorMsg = `Single Product - Variant: ${variantId}, Error: ${
          error.message || error
        }`;
        localStorage.setItem("catalog_last_error", errorMsg);
        console.error("[CATALOG STORED ERROR]:", errorMsg);

        // Remove processing class on error
        button.classList.remove("processing");

        handleCatalogCartError(error, button, originalText);
      });
  }

  function handleBundleAddToCart(button, productCard) {
    if (CATALOG_DEBUG)
      console.log("[CATALOG_DEBUG] Handling bundle add to cart");

    const selectedFrameSize = productCard.querySelector(
      ".catalog-section__product-card-frame-size-btn.is-active",
    );
    let mainVariantId;

    console.log(
      "[CATALOG_DEBUG] Bundle - Selected frame button:",
      selectedFrameSize,
    );
    console.log(
      "[CATALOG_DEBUG] Bundle - Button data-variant-id:",
      button.getAttribute("data-variant-id"),
    );

    if (selectedFrameSize) {
      mainVariantId = selectedFrameSize.dataset?.variantId;
      const isAvailable = selectedFrameSize.dataset?.available === "true";

      console.log(
        "[CATALOG_DEBUG] Bundle - Using selected frame variant:",
        mainVariantId,
        "Available:",
        isAvailable,
      );

      if (!isAvailable) {
        button.disabled = true;
        button.textContent = "Out of Stock";
        button.classList.remove("processing");
        return;
      }
    } else {
      mainVariantId = button.getAttribute("data-variant-id");
      console.log(
        "[CATALOG_DEBUG] Bundle - No selected frame, using button variant:",
        mainVariantId,
      );
    }

    if (!mainVariantId) {
      console.error("[CATALOG_DEBUG] No main variant ID found for bundle");
      button.classList.remove("processing");
      return;
    }

    // Get bundle item IDs
    const sideshieldId = button.dataset?.sideshieldId;
    const riserId = button.dataset?.riserId;
    const floatieId = button.dataset?.floatieId;

    console.log("[CATALOG_DEBUG] Kit item IDs detected:", {
      sideshieldId: sideshieldId || "MISSING",
      riserId: riserId || "MISSING",
      floatieId: floatieId || "MISSING",
    });

    // Update button state to loading for availability check
    const originalText = button.textContent || "Add to Cart";
    button.textContent = "Adding Items...";
    button.disabled = true;

    // Get product name and kit item details from data attributes
    const bundleCard = productCard.closest('[data-is-bundle="true"]');
    const mainProductTitle = bundleCard?.dataset.mainProductTitle || "Product";
    const mainVariantTitle = bundleCard?.dataset.mainVariantTitle || "";

    // Get kit item titles from data attributes
    const sideshieldTitle = bundleCard?.dataset.sideshieldTitle || "";
    const sideshieldVariantTitle =
      bundleCard?.dataset.sideshieldVariantTitle || "";
    const riserTitle = bundleCard?.dataset.riserTitle || "";
    const riserVariantTitle = bundleCard?.dataset.riserVariantTitle || "";
    const floatieTitle = bundleCard?.dataset.floatieTitle || "";
    const floatieVariantTitle = bundleCard?.dataset.floatieVariantTitle || "";

    // Check availability of ONLY kit items before adding to cart
    // Don't check main product because frame size availability is already handled
    const itemsToCheck = [];

    if (sideshieldId)
      itemsToCheck.push({
        id: sideshieldId,
        name: "Side Shield",
        displayName: sideshieldTitle,
        variantName: sideshieldVariantTitle,
      });
    if (riserId)
      itemsToCheck.push({
        id: riserId,
        name: "Nose Pad Riser",
        displayName: riserTitle,
        variantName: riserVariantTitle,
      });
    if (floatieId)
      itemsToCheck.push({
        id: floatieId,
        name: "Floatie",
        displayName: floatieTitle,
        variantName: floatieVariantTitle,
      });

    // Check availability of kit items (if any exist)
    if (itemsToCheck.length === 0) {
      // No kit items to check, proceed directly to add to cart
      // This happens when main product has no kit items
      console.log(
        "[CATALOG_DEBUG] No kit items to check, adding to cart directly",
      );
      button.textContent = "Adding Items...";
      addBundleToCart(
        button,
        mainVariantId,
        sideshieldId,
        riserId,
        floatieId,
        originalText,
      );
      return;
    }

    // Check availability of kit items only
    checkKitItemsAvailability(itemsToCheck)
      .then((availabilityResults) => {
        const unavailableItems = availabilityResults.filter(
          (item) => !item.available,
        );

        if (unavailableItems.length > 0) {
          // Some kit items are out of stock - show custom modal
          button.textContent = "Kit Item OOS";
          button.classList.remove("processing");

          const errorMsg = `Kit OOS - ${unavailableItems
            .map((i) => i.name)
            .join(", ")}`;
          console.warn("[CATALOG_DEBUG]", errorMsg);
          localStorage.setItem("catalog_last_error", errorMsg);

          // Show custom modal with detailed OOS information
          setTimeout(() => {
            showOOSModal(unavailableItems);
            button.disabled = false;
            button.textContent = originalText;
          }, 100);

          return;
        }

        // All kit items are available, proceed with adding to cart
        button.textContent = "Adding Items...";

        addBundleToCart(
          button,
          mainVariantId,
          sideshieldId,
          riserId,
          floatieId,
          originalText,
        );
      })
      .catch((error) => {
        console.error(
          "[CATALOG_DEBUG] Error checking kit availability:",
          error,
        );

        // If availability check fails, try adding anyway (fallback)
        console.log(
          "[CATALOG_DEBUG] Proceeding with add to cart despite availability check failure",
        );
        button.textContent = "Adding Items...";
        addBundleToCart(
          button,
          mainVariantId,
          sideshieldId,
          riserId,
          floatieId,
          originalText,
        );
      });
  }

  // Function to show custom OOS modal
  function showOOSModal(unavailableItems) {
    // All items in unavailableItems array are kit items only
    // Main product OOS is already handled by button state

    // Helper function to check if variant title should be shown
    const shouldShowVariantTitle = (variantTitle) => {
      if (!variantTitle) return false;
      const lowerTitle = variantTitle.toLowerCase();
      return (
        lowerTitle !== "default" &&
        lowerTitle !== "default title" &&
        variantTitle.trim() !== ""
      );
    };

    // Create modal HTML
    const modalHTML = `
      <div class="catalog-modal-overlay" id="catalogOOSModal">
        <div class="catalog-modal">
          <div class="catalog-modal-header">
            <h2 class="catalog-modal-title">Unable to Add Kit to Cart</h2>
            <button class="catalog-modal-close" onclick="closeCatalogOOSModal()">&times;</button>
          </div>
          <div class="catalog-modal-body">
            <div class="catalog-modal-section">
              <h3 class="catalog-modal-section-title">Kit Items Out of Stock</h3>
              ${unavailableItems
                .map(
                  (item) => `
                <div class="catalog-modal-item">
                  <div class="catalog-modal-icon">❌</div>
                  <div class="catalog-modal-item-content">
                    <p class="catalog-modal-item-title">${
                      item.displayName || item.productTitle || item.name
                    }</p>
                    ${
                      shouldShowVariantTitle(item.variantName) ||
                      shouldShowVariantTitle(item.variantTitle)
                        ? `
                      <p class="catalog-modal-item-variant">${
                        item.variantName || item.variantTitle
                      }</p>
                    `
                        : ""
                    }
                    <span class="catalog-modal-item-badge">Out of Stock</span>
                  </div>
                </div>
              `,
                )
                .join("")}
            </div>
          </div>
          <div class="catalog-modal-footer">
            <p class="catalog-modal-footer-text">These kit items are currently unavailable. Please check back later or contact our support team for assistance.</p>
            <button class="catalog-modal-button" onclick="closeCatalogOOSModal()">Got It</button>
          </div>
        </div>
      </div>
    `;

    // Remove existing modal if any
    const existingModal = document.getElementById("catalogOOSModal");
    if (existingModal) {
      existingModal.remove();
    }

    // Add modal to body
    document.body.insertAdjacentHTML("beforeend", modalHTML);

    // Show modal with animation
    setTimeout(() => {
      const modal = document.getElementById("catalogOOSModal");
      if (modal) {
        modal.classList.add("active");
      }
    }, 10);

    // Close on overlay click
    const overlay = document.getElementById("catalogOOSModal");
    if (overlay) {
      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) {
          closeCatalogOOSModal();
        }
      });
    }

    // Close on escape key
    const escapeHandler = function (e) {
      if (e.key === "Escape") {
        closeCatalogOOSModal();
        document.removeEventListener("keydown", escapeHandler);
      }
    };
    document.addEventListener("keydown", escapeHandler);
  }

  // Global function to close modal
  window.closeCatalogOOSModal = function () {
    const modal = document.getElementById("catalogOOSModal");
    if (modal) {
      modal.classList.remove("active");
      setTimeout(() => {
        modal.remove();
      }, 300);
    }
  };

  // Helper function to check kit items availability
  async function checkKitItemsAvailability(items) {
    const results = [];

    for (const item of items) {
      try {
        const response = await fetch(`/products.json?variant=${item.id}`);
        if (response.ok) {
          const data = await response.json();

          // Find the variant in the product data
          let variantAvailable = false;
          let productTitle = "";
          let variantTitle = "";

          if (data.products && data.products.length > 0) {
            for (const product of data.products) {
              const variant = product.variants.find(
                (v) => v.id.toString() === item.id.toString(),
              );
              if (variant) {
                variantAvailable = variant.available;
                productTitle = product.title;
                variantTitle = variant.title;
                break;
              }
            }
          }

          results.push({
            id: item.id,
            name: item.name,
            displayName: item.displayName,
            variantName: item.variantName, // From data attributes
            available: variantAvailable,
            productTitle: productTitle,
            variantTitle: variantTitle,
          });
        } else {
          // If we can't check, assume available (fallback)
          results.push({
            id: item.id,
            name: item.name,
            displayName: item.displayName,
            variantName: item.variantName,
            available: true,
            productTitle: "",
            variantTitle: "",
          });
        }
      } catch (error) {
        console.error(
          `[CATALOG_DEBUG] Error checking availability for ${item.name}:`,
          error,
        );
        // If check fails, assume available (fallback)
        results.push({
          id: item.id,
          name: item.name,
          displayName: item.displayName,
          variantName: item.variantName,
          available: true,
          productTitle: "",
          variantTitle: "",
        });
      }
    }

    return results;
  }

  // Separated function to actually add bundle to cart
  function addBundleToCart(
    button,
    mainVariantId,
    sideshieldId,
    riserId,
    floatieId,
    originalText,
  ) {
    // Prepare items array
    const items = [];

    // Add main product
    items.push({ id: parseInt(mainVariantId), quantity: 1 });

    // Add bundle items
    if (sideshieldId) {
      items.push({ id: parseInt(sideshieldId), quantity: 1 });
    }
    if (riserId) {
      items.push({ id: parseInt(riserId), quantity: 1 });
    }
    if (floatieId) {
      items.push({ id: parseInt(floatieId), quantity: 1 });
    }

    if (CATALOG_DEBUG)
      console.log("[CATALOG_DEBUG] Adding bundle items to cart:", items);

    console.log(
      "[CATALOG_DEBUG] Bundle add to cart - Main variant:",
      mainVariantId,
      "Kit items:",
      { sideshieldId, riserId, floatieId },
    );

    // Add bundle to cart using items array
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.json();
      })
      .then((data) => {
        if (CATALOG_DEBUG) {
          console.log("[CATALOG_DEBUG] Bundle added to cart:", data);
        }

        // Clear any stored errors on success
        localStorage.removeItem("catalog_last_error");

        // Remove processing class
        button.classList.remove("processing");

        // Handle success like bestsellers
        handleCatalogCartSuccess(button, originalText, true);
      })
      .catch((error) => {
        console.error("[CATALOG_DEBUG] Error adding bundle to cart:", error);

        // Store error in localStorage for debugging page reloads
        const errorMsg = `Bundle - Main: ${mainVariantId}, Items: ${JSON.stringify(
          { sideshieldId, riserId, floatieId },
        )}, Error: ${error.message || error}`;
        localStorage.setItem("catalog_last_error", errorMsg);
        console.error("[CATALOG STORED ERROR]:", errorMsg);

        // Remove processing class on error
        button.classList.remove("processing");

        handleCatalogCartError(error, button, originalText);
      });
  }

  function handleCatalogCartSuccess(button, originalText, isBundle = false) {
    if (!button) return;

    // Update cart count callback (like bestsellers)
    window.SLIDECART_UPDATED = function (cart) {
      const cartCountElem = document.querySelector(".header-new__cart-count");
      if (cartCountElem && cart)
        cartCountElem.textContent = cart.item_count || 0;
    };

    button.textContent = isBundle ? "Added!" : "Added!";

    // Open cart drawer like bestsellers
    setTimeout(() => {
      if (typeof SLIDECART_UPDATE === "function") SLIDECART_UPDATE();
      if (typeof SLIDECART_OPEN === "function") SLIDECART_OPEN();
    }, 300);

    // Reset button
    setTimeout(() => {
      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }, 2000);
  }

  function handleCatalogCartError(error, button, originalText) {
    if (CATALOG_DEBUG)
      console.error("[CATALOG_DEBUG] Add to cart error:", error);
    if (button) {
      button.disabled = false;
      button.textContent = originalText;
      button.classList.remove("processing");

      // Show error message briefly
      button.textContent = "Error - Try Again";
      button.style.backgroundColor = "#dc3545";

      setTimeout(() => {
        button.textContent = originalText;
        button.style.backgroundColor = "";
      }, 2000);
    }
  }

  // Add click handlers for add to cart buttons with capture phase
  document.addEventListener(
    "click",
    (event) => {
      if (
        event.target &&
        event.target.classList.contains(
          "catalog-section__product-card-add-to-cart-btn",
        )
      ) {
        handleAddToCartClick(event);
      }
    },
    true,
  ); // Use capture phase to ensure we handle it first

  // Update availability when frame sizes are selected
  document.addEventListener("click", (event) => {
    if (
      event.target &&
      event.target.classList.contains(
        "catalog-section__product-card-frame-size-btn",
      )
    ) {
      const card = event.target.closest(".catalog-section__product-card");
      if (card) {
        // Small delay to allow selection state to update
        setTimeout(() => {
          updateCatalogProductState(card);
        }, 10);
      }
    }
  });

  // Initial state update for all cards
  const allCards = document.querySelectorAll(".catalog-section__product-card");
  if (allCards && allCards.length > 0) {
    allCards.forEach((card) => {
      if (card) updateCatalogProductState(card);
    });
  }

  if (CATALOG_DEBUG) {
    console.log("[CATALOG_DEBUG] Add to cart functionality initialized");
  }
}
